export const ADD_MARKER = 'ADD_MARKER';
export const REPLACE_MARKERS = 'REPLACE_MARKERS';
export const UPDATE_SNACKBAR = 'UPDATE_SNACKBAR';
export const SNACKBAR_SUCCESS_COLOR = 'green';
export const SNACKBAR_ERROR_COLOR = 'red';
